<template>
  <div class="wrapper">
    <BPMNNodeBase :item="item" @updateName="updateName"/>
    <div class="container-fluid mt-2">
      <div class="form-group">
        <label>Standard-Weg</label>
        <input type="text" class="form-control" v-model="item.attributes.default.value" @blur="updateDefFlow"/>
      </div>
    </div>
  </div>
</template>

<script>
import BPMNNodeBase from './BPMNNodeBase.vue'

export default {
  props: ["item"],
  components: {
    BPMNNodeBase
  },
  data() {
    return {
      cond: '',
      condXml: false,
    }
  },
  methods: {
    updateName(e) {
      this.$emit('updateName',e);
    },
    updateDefFlow() {
      console.log(this.item);
      this.$emit('update');
    }
  }
}
</script>
